import { render, staticRenderFns } from "./ImageRotate.vue?vue&type=template&id=1623193c&"
import script from "./ImageRotate.vue?vue&type=script&lang=js&"
export * from "./ImageRotate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports